@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;700&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  /* FinGuard Aura Palette (Blue to Emerald) */
  --bg-main: #FFFFFF;
  --bg-surface: #F8FAFC;
  --bg-card: #FFFFFF;
  
  --brand-blue: #2563EB;
  --brand-emerald: #059669;
  --aura-gradient: linear-gradient(135deg, #2563EB 0%, #059669 100%);
  
  --accent-primary: #059669; 
  --accent-secondary: #0F172A;
  --border-light: #E2E8F0;
  --ink-primary: #0F172A;
  --ink-secondary: #475569;
  --ink-muted: #94A3B8;
  
  --risk-red: #DC2626;
  --risk-amber: #D97706;
  --risk-green: #059669;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--bg-main);
  color: var(--ink-primary);
  font-family: 'Manrope', sans-serif;
  -webkit-font-smoothing: antialiased;
  min-height: 100vh;
}

* {
  min-width: 0;
}

html {
  overflow-x: hidden;
}

@layer components {
  .finvera-card {
    @apply bg-white border border-slate-200 rounded-[22px] md:rounded-[32px] p-5 md:p-10 transition-all duration-300 hover:shadow-xl hover:shadow-emerald-900/5;
  }

  .finvera-btn-primary {
    @apply bg-emerald-600 hover:bg-emerald-700 text-white px-5 md:px-8 py-3.5 md:py-4 rounded-[14px] md:rounded-[16px] font-bold text-[14px] md:text-[15px] transition-all active:scale-95 shadow-lg shadow-emerald-600/20;
  }

  .finvera-btn-secondary {
    @apply bg-slate-100 hover:bg-slate-200 text-slate-900 px-5 md:px-8 py-3.5 md:py-4 rounded-[14px] md:rounded-[16px] font-bold text-[14px] md:text-[15px] transition-all active:scale-95;
  }

  .finvera-input {
    @apply bg-slate-50 border border-slate-200 rounded-[18px] md:rounded-[24px] px-5 md:px-8 py-4 md:py-6 text-[16px] md:text-[17px] font-medium focus:outline-none focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500/50 transition-all placeholder:text-slate-400;
  }

  .finvera-badge {
    @apply px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest border border-slate-200 bg-white text-slate-600;
  }

  .glass-card {
    @apply bg-white border border-slate-200 rounded-[20px] md:rounded-[24px] shadow-sm shadow-slate-200/50 overflow-hidden;
  }

  .bento-inner {
    @apply flex flex-col p-5 md:p-6;
  }

  .ios-label {
    @apply block mb-4 text-[10px] md:text-[11px] font-black uppercase tracking-[0.22em] text-slate-400;
  }

  .iphone-btn {
    @apply inline-flex items-center justify-center gap-2 rounded-[14px] px-5 py-3 font-bold transition-all active:scale-95;
  }
}

.mono-data {
  font-family: 'JetBrains Mono', monospace;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.no-scrollbar {
  scrollbar-width: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

@keyframes fade-in-up {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes gradient-x {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}
.animate-gradient-x {
  background-size: 200% 200%;
  animation: gradient-x 3s ease infinite;
}

@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin-slow {
  animation: spin-slow 12s linear infinite;
}

.animate-finvera {
  animation: fade-in-up 0.6s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}
